import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import IconCheck from 'assets/icon-marketing-integrations-check.svg';
import {
  BulkExportActions,
  BulkExportContainer,
  BulkExportSend,
  BulkExportSentBody,
  BulkExportSentIcon,
  BulkExportSubject,
  BulkExportText,
  BulkExportTitle
} from 'routes/App/reports/modals/BulkExport/styles';

const TITLE_ID = 'bulk-export-sent-title';

const BulkExportSentModal = ({
  open,
  email,
  emailSubject,
  alreadyInProgress,
  onClose
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    scroll='body'
    aria-labelledby={TITLE_ID}
  >
    <BulkExportContainer>
      <BulkExportSentBody>
        <BulkExportSentIcon>
          <img src={IconCheck} alt='' />
        </BulkExportSentIcon>
        <BulkExportTitle id={TITLE_ID}>
          {alreadyInProgress
            ? 'Your reports are already on the way'
            : 'Your reports are on the way'}
        </BulkExportTitle>
        {alreadyInProgress ? (
          <BulkExportText>
            We&apos;re still preparing the Sales Summary reports you requested.
            They&apos;ll be emailed to <strong>{email}</strong> shortly.
          </BulkExportText>
        ) : (
          <>
            <BulkExportText>
              We&apos;re emailing the Sales Summary reports for all selected
              locations to <strong>{email}</strong>.
            </BulkExportText>
            <BulkExportText>
              It may take a few minutes to arrive.
            </BulkExportText>
          </>
        )}
        <BulkExportSubject>
          <span>Look for this subject</span>
          <p>{emailSubject}</p>
        </BulkExportSubject>
        <BulkExportActions>
          <BulkExportSend className='solid' onClick={onClose}>
            <span>Got it</span>
          </BulkExportSend>
        </BulkExportActions>
      </BulkExportSentBody>
    </BulkExportContainer>
  </Dialog>
);

BulkExportSentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  email: PropTypes.string,
  emailSubject: PropTypes.string,
  alreadyInProgress: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

BulkExportSentModal.defaultProps = {
  email: '',
  emailSubject: '',
  alreadyInProgress: false
};

export default BulkExportSentModal;
